// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your Firebase config
// const firebaseConfig = process.env.REACT_APP_FIREBASE_CONFIG;
const firebaseConfig = {
  apiKey: "AIzaSyD5XI3JDZCH3tGLj8LqjkUQUdhUOM6h9bg",
  authDomain: "oba-app-auth.firebaseapp.com",
  projectId: "oba-app-auth",
  storageBucket: "oba-app-auth.firebasestorage.app",
  messagingSenderId: "288423710265",
  appId: "1:288423710265:web:95d622462515062c8187e8",
  measurementId: "G-NS2Y3GLBB0",
};
const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);

export { auth };
